<template>
   <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
               {{ payload.name }} <sup>{{ payload.status == "A" ? 'Inactive: verification required' : 'Active' }}</sup>
              </div>

              <div class="modal-body">
                <div v-if="loading" class="loading-indicator">Working...</div>
                <div class="row">
                  <div class="col-md-12">
                     <div v-if="payload.status == 'C'">
                       Your domain is active. It means you can create email under it. You should be able to receiver and send messages via you emails.
                      </div>
                    <div v-else>
                      To complete verification of this domain, you must add a TXT record in the domain's DNS settings with the values below:
                      <table>
                        <tr>
                          <td><b>Record Type:</b></td>
                          <td>TXT (Text)</td>
                        </tr>
                        <tr>
                          <td><b>TXT Name*:</b></td>
                          <td>_amazonses.{{payload.name}}</td>
                        </tr>
                        <tr>
                          <td><b>TXT Value:</b></td>
                          <td>{{payload.verification_code}}</td>
                        </tr>
                      </table>
                      <div>
                        A TXT record is a type of DNS record that provides additional information about your domain. The procedure for adding TXT records to your domain's DNS settings depends on who provides your DNS service.
                      </div>
                      <div>
                          NOTE: If your DNS provider does not allow underscores in record names, you can omit <b>_amazonses</b> from the record name. To help you easily identify this record within your domain's DNS settings, you can optionally prefix the record value with amazonses
                      </div>
                    </div>

                    <div>
                        
                       
                    </div>
                  </div>
                
                </div>
              </div>

              <div class="modal-footer">
                
                <slot name="footer">
                  <button class="btn" @click="$emit('close')">
                    Close
                  </button>
                </slot>
              </div>
              
            </div>
          </div>
        </div>
      </transition>
</template>

<script>
//import { backendUrl } from '@/config';
//import axios from 'axios'
export default {
  name: 'DomainDetails',
  props: ['payload'],
  data() {
    return {
      loading: false,
      success: false
    }
  },
  mounted () {
     /*let obj = this
    axios
      .get(backendUrl+'message', {
        params: {
          id: obj.id
        }
      })
      .then(response => {
        obj.output = response.data.result[0]
      })
      .catch(error => {
        alert(error.message)
      })
      .finally(() => obj.loading = false)*/
  },
  /*methods: {
    replyMessage() {
      this.$emit('replymessage', this.output)
    }
  }*/
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }
  
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  
  .modal-container {
    width: 600px;
    margin: 0px auto;
    padding: 10px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  
  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }
  
  .modal-body {
    margin: 5px 0;
  }
  
  .modal-default-button {
    float: right;
  }
  
  .modal-enter {
    opacity: 0;
  }
  
  .modal-leave-active {
    opacity: 0;
  }
  
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .row div{
    padding:5px 0;
  }
</style>